<template>
  <section :style="{ background: linearGradientStyle }" class="action-bar dashboardHeader">
    <div class="leftButtonBlock">
      <div class="buttonHeader" style="width: 200px;"> 
        <v-autocomplete
          v-model="selectedTypes"
          :items="getAvailableTypes"
          :placeholder="$t('global.button_aircraft_type')"
          multiple
          chips
          clearable
          back
          @change="submitFilter"
          class="dashboardFilter"
          no-data-text="Type not found" 
        >
          <!-- Custom selection display -->
          <template v-slot:selection="{ item, index }">
            <v-chip class="dashboardChip" v-if="selectedTypes.length <= 1 || index < 1">
              {{ item }}
            </v-chip>
            <v-chip class="dashboardChip" v-else-if="index === 1" >
              ...
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
      
      <div class="buttonHeader" style="width: 200px;">
        <v-autocomplete
          v-model="selectedStatuses"
          :items="statuses"
          :placeholder="$t('global.button_status')"
          chips
          clearable
          @change="submitFilter"
          class="dashboardFilter"
          no-data-text="Status not found" 
        >
          <!-- Custom selection display -->
          <template v-slot:selection="{ item }">
            <v-chip class="dashboardChip" >
              {{ item.text }}
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </div>
    <div class="headerContainer">
      <div class="searchBar">
        <v-text-field
          v-model="filterData"
          :placeholder="$t(placeholder)"
          solo
          flat
          dense
          clearable
          hide-details
          background-color="white"
          @keyup.enter="submitFilter"
          @click:clear="clearSearch"
        ></v-text-field>
      </div>
      <div class="rightButtonBlock">
        <div class="buttonHeader">
          <button
            v-if="isAHAdmin"
            class="btn hollow is-pulled-right block"
            @click="activateAddHCModal()"
          >
            {{ $t('global.button_add_hc') }}
          </button>
        </div>
      </div>
      </div>
    <modal :title="addHCModal.title" :modalName="addHCModal.name" width="460px" height="500px">
      <ModalAddHC />
    </modal>
  </section>
</template>
<style lang="scss">
.dashboardHeader {
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
}

.leftButtonBlock {
  display: flex;
  align-items: center;
  gap: 20px;
}

.buttonHeader {
  display: inline-block;
  position: relative; 
}


.dashboardFilter .v-input__control input {
  caret-color: transparent !important;  
  padding-left: 10px !important;  
}

.dashboardFilter .v-input__control input::placeholder {
  color: rgba(0, 0, 0, 0.54); 
}

.dashboardFilter .v-input__control {
  height: 33px; 
  display: flex;
  align-items: center;
}

.dashboardFilter .v-input__slot {
  height: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start; 
  gap: 5px; 
}


.dashboardChip{
  font-size: 12px !important; 
  height: 22px !important; 
  margin: 2px; 
}

.v-select.v-select--chips .v-select__selections {
  min-height: 12px !important;
}

.searchBar {
  width: 45%;
}

.headerContainer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.dashboardHeader-input {
  background-color: transparent !important;
  height: 30px;
  width: 100%;
  font-size: 16px;
  border: 1px solid #ccc; 

}



.dashboardHeader-input::placeholder {
  color: white;
}

.dashboardFilter input::placeholder {
  color: white !important;
}
.v-autocomplete:not(.v-input--is-focused).v-select--chips input { max-height: 25px !important; }
</style>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Modal from './modals/Modal';
import ModalAddHC from './modals/ModalAddHC';
import ModalUploadFiles from './modals/ModalUploadFiles'
import ModalConfirm from './modals/ModalConfirm'
import ModalBanHC from './modals/ModalBanHC'
import ModalUnbanHC from './modals/ModalUnbanHC'
import bus from '../event/bus';

export default {
  name: 'DashboardHeader',
  components: {
    Modal,
    ModalAddHC,
    ModalUploadFiles,
    ModalConfirm,
    ModalBanHC,
    ModalUnbanHC
  },
  data() {
    return {
      filterData: '',
      placeholder: 'global.search_placeholder',
      addHCModal: {
        name: 'addHC',
        title: 'global.button_add_hc'
      },
      selectedTypes: [],
      selectedStatuses: '', // only one status can be selected at a time.
      statuses: [
        { text: 'Connected', value: 'connected' },
        { text: 'Disconnected', value: 'disconnected'},
        { text: 'Banned', value: 'banned'},
        { text: 'Pending import', value: 'pending_import'}
      ]
    };
  },
  computed: {
    ...mapState(['userStore']),
    ...mapGetters('fleetStore', [
      'areAllFleetAdded',
      'isAnyActiveSelection',
      'selectedHeliCounter',
      'getSelectedDetailed',
      'getFleetQuery',
      'getAvailableTypes'
    ]),
    ...mapGetters('userStore', ['isAdmin', 'isAHAdmin']),
    linearGradientStyle() {
      const startColor = window.env.VUE_APP_BACKGROUND_1;
      const endColor = window.env.VUE_APP_BACKGROUND_2;
      return `linear-gradient(to left, ${startColor}, ${endColor})`;
    }
  },

  mounted() {
    this.restoreFilters();
  },
  methods: {
    ...mapActions('fleetStore', ['setFleetQuery', 'setFetchedFleet']),
    ...mapActions('appStore', ['openModal', 'closeModal']),
    activateAddHCModal() {
      this.openModal(this.addHCModal.name);
    },

    clearSearch() {
      this.filterData = '';
      this.submitFilter();
    },
  
    restoreFilters() {
      const fleetQuery = this.getFleetQuery;
      
      if (!fleetQuery) return; 

      const params = new URLSearchParams(fleetQuery);

      if (params.has('query')) {
        this.filterData = params.get('query');
      }

      if (params.has('display_types')) {
        // Split the comma-separated string back into an array
        this.selectedTypes = params.get('display_types').split(',');
      }

      if (params.has('statuses')) {
        this.selectedStatuses = params.get('statuses'); 
      }
    },
  submitFilter() {
    bus.$emit('submitFilter', { state: true });

    let queryParams = [];
    if (this.filterData) {
      queryParams.push(`query=${this.filterData}`);
    }
    if (this.selectedTypes && this.selectedTypes.length > 0) {
      queryParams.push(`display_types=${this.selectedTypes.join(',')}`);
    }
    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      queryParams.push(`statuses=${this.selectedStatuses}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    this.setFleetQuery(queryString);

    this.$requester
      .get(`/helicopters${queryString}`)
      .then(response => {
        // Check if response.data is a string and parse it
        const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        this.setFetchedFleet({ fleets: responseData.fleets });
      })
      .catch(function (error) {
        console.log("fetch fleet error", error);
      });
  }

  }
};
</script>
